module.exports = __webpack_public_path__ + "img/funny.c737f4f4.png";